import { PersonalInformationDto } from '../../../interfaces/dtos/PersonalInformationDto';
import { PersonalInformation } from '../../../interfaces/PersonalInformation';
import transformAddress from './transformAddress';
import transformConsent from './transformConsent';
import transformCorrespondence from './transformCorrespondence';
import transformEmails from './transformEmails';
import transformIdentification from './transformIdentification';
import transformPhones from './transformPhones';

export default function transformPiData(personalInfoDto: PersonalInformationDto): PersonalInformation {
  return {
    identification: transformIdentification(personalInfoDto.data.identification, personalInfoDto.behaviours.identificationBehaviour),
    address: transformAddress(personalInfoDto.data.address, personalInfoDto.behaviours.addressBehaviour),
    correspondence: transformCorrespondence(personalInfoDto.data.correspondence, personalInfoDto.behaviours.correspondenceBehaviour),
    consent: transformConsent(personalInfoDto.data.consent),
    emails: transformEmails(personalInfoDto.data.emails, personalInfoDto.behaviours.emailBehaviour),
    phones: transformPhones(personalInfoDto.data.phoneNumbers, personalInfoDto.behaviours.phoneNumbersBehaviour),
  };
}
